import QCol from './src/QCol';

QCol.install = Vue => {
  Vue.component(QCol.name, QCol);
};

export default QCol;
